import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ProjectsService } from '../../services/projects.service'

@Component({
  selector: 'app-add-annotations-modal',
  templateUrl: './add-annotations-modal.page.html',
  styleUrls: ['./add-annotations-modal.page.scss'],
})
export class AddAnnotationsModalPage implements OnInit {

  public annotationText;
  public isLinkedToAsset;
  private linkedAsset;
  private sceneIndex;
  private scenes = [];

  constructor(public modalController: ModalController, public projectService: ProjectsService) { }

  ngOnInit() {
  }

  closeModal() {
    var annotation = {
      "annotationText": this.annotationText,
      "isLinkedToAsset": this.isLinkedToAsset,
      "linkedAsset": this.linkedAsset
    }
    this.modalController.dismiss(annotation);
  }
}
